module.exports = __webpack_public_path__ + "media/images/city/071-burj-al-arab-3aa5d333209e2695ad6fe8146fa05cbc.svg";